// Pulls a human-readable message out of an axios error, checking every shape
// the backend uses across different endpoints (structured {error:{message}},
// plain {message}, legacy {msg}, or the raw error's own .message) before
// falling back to a caller-supplied default.
export const errorMessage = (error, fallback) => (
  error?.response?.data?.error?.message
  || error?.response?.data?.message
  || error?.response?.data?.msg
  || error?.message
  || fallback
);
